import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-678ae7a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-8 px-5 mt-5 mx-auto" }
const _hoisted_5 = { class: "card card-primary" }
const _hoisted_6 = {
  key: 0,
  class: "overlay"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-2x fa-sync-alt fa-spin" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = { class: "card-title" }
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "appName" }, "Nombre aplicación", -1))
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "appCode" }, "Id Aplicación", -1))
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "card-footer text-center" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.editMode ? 'Editar' : 'Crear nueva') + " aplicación ", 1)
            ]),
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass({'form-control': true,  'is-invalid': _ctx.v$.applicationName.$error,  'is-valid': !_ctx.v$.applicationName.$error }),
                    id: "appName",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.v$.applicationName.$model) = $event)),
                    placeholder: "Nombre de la aplicación"
                  }, null, 2), [
                    [_vModelText, _ctx.v$.applicationName.$model]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.applicationName.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: "error invalid-feedback",
                      key: error.$uid
                    }, _toDisplayString(error.$message), 1))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass({'form-control': true,  'is-invalid': _ctx.v$.applicationCode.$error,  'is-valid': !_ctx.v$.applicationCode.$error }),
                    id: "appCode",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.v$.applicationCode.$model) = $event)),
                    placeholder: "Id de la Aplicación",
                    disabled: _ctx.editMode
                  }, null, 10, _hoisted_16), [
                    [_vModelText, _ctx.v$.applicationCode.$model]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.applicationCode.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: "error invalid-feedback",
                      key: error.$uid
                    }, _toDisplayString(error.$message), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-success",
                  onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.saveApplication && _ctx.saveApplication(...args)))
                }, " Guardar "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger ml-3",
                  onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.goToAppsList && _ctx.goToAppsList(...args)))
                }, " Cancelar ")
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}